import {imageField, marketingPhotoField, postCode, progressBar, mapMarker, coordinate} from './stepper-functions';
import {phoneValidate} from '../util/phoneValidate';

$(function() {
    let $stepperForm = $('#signUpForm');
    let $stepCurrentElement = '';
    let stepsCount = 0;
    let stepCurrent = 0;

    // Init condition
    if($stepperForm.length || $('.profile-form').length) {
        initStepper();
    }

    if($stepperForm.length) {
        cancelPayment();
        currentStep();
    }

    // Next Button Click
    $stepperForm.find('.next-btn').on('click', function (e) {
        e.preventDefault();
        stepsCount = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size();
        $stepCurrentElement = $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent);
        //console.log($stepCurrentElement);
        //console.log(stepCurrent);
        if(validateField($stepCurrentElement)) {
            if(stepCurrent <= (stepsCount - 1) && stepCurrent !== (stepsCount + 1)) {
                stepCurrent = stepCurrent + 1;
                if(stepCurrent !== stepsCount) {
                    progressBar.init($stepperForm, (stepsCount - 1), stepCurrent);
                    $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').addClass('d-none');
                    $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent).removeClass('d-none');
                }
                $stepperForm.submit();
            }
            if(stepCurrent === (stepsCount - 1)) {
                $stepperForm.find('.next-btn').children('span').text('Finish');
            }
            if(stepCurrent <= 1) {
                $stepperForm.find('.prev-btn').attr('disabled', true);
                $stepperForm.find('.prev-btn').addClass('disabled');
            } else {
                $stepperForm.find('.prev-btn').attr('disabled', false);
                $stepperForm.find('.prev-btn').removeClass('disabled');
            }
        } else {
            console.log('Invalid field');
        }
    });

    // Prev Button Click
    $stepperForm.find('.prev-btn').on('click', function (e) {
        e.preventDefault();
        stepsCount = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size();
        $stepCurrentElement = $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent);
        if(stepCurrent > 0 && stepCurrent <= stepsCount) {
            stepCurrent = stepCurrent - 1;
            progressBar.init($stepperForm, stepsCount, stepCurrent);
            $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').addClass('d-none');
            $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent).removeClass('d-none');
        }
        if(stepCurrent <= 1) {
            $stepperForm.find('.prev-btn').attr('disabled', true);
            $stepperForm.find('.prev-btn').addClass('disabled');
        }
        if(stepCurrent < stepsCount) {
            $stepperForm.find('.next-btn').children('span').text('Next');
        }
    });

    // Submit Form
    $stepperForm.on('submit', function (e) {
        e.preventDefault();
        let formData = new FormData(this);
        formData.append('step', stepCurrent);

        const url = new URL(window.location.href);
        url.searchParams.set('n', stepCurrent);
        window.history.replaceState(null, null, url);

        switch (stepCurrent) {
            case 1: {
                createUser(formData);
                break;
            }
            case 2: {
                updateDetails(formData);
                break;
            }
            case 3: {
                updateMapMarkers(formData);
                break;
            }
            case 4: {
                updateAdviceAndSpecialties(formData);
                break;
            }
            case 5: {
                updateFees(formData);
                break;
            }
            case 6: {
                $('.stepper-footer .next-btn span').text('sending...');
                url.searchParams.set('n', 5);
                window.history.replaceState(null, null, url);
                createPayment(formData);
                break;
            }
        }
    });

    // Return payment function
    function cancelPayment() {
        let params = (new URL(document.location)).searchParams;
        let cancel = params.get('cancel');
        if(cancel) {
            stepsCount = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size() - 1;
            stepCurrent = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size() - 1;
            progressBar.next($stepperForm, stepsCount, stepCurrent);
            $stepperForm.find('.next-btn').children('span').text('Finish');
            $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').addClass('d-none');
            $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent).removeClass('d-none');
            $stepperForm.find('#postCode').children('.item-pc').each(function() {
                let radius = parseFloat($(this).find('.input-radius').val());
                let latitude = parseFloat($(this).find('.input-lat').val());
                let longitude = parseFloat($(this).find('.input-lng').val());
                coordinate.push({lat: latitude, lng: longitude, radius: radius });
            });
            mapMarker.showMarker(postCode.centerInit, coordinate);
        }
    }

    // Go to Step
    function currentStep() {
        let params = (new URL(document.location)).searchParams;
        let step = params.get('n');
        if(step) {
            stepsCount = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size() - 1;
            stepCurrent = parseInt(step);
            progressBar.next($stepperForm, stepsCount, stepCurrent);
            if(stepsCount == stepCurrent){
                $stepperForm.find('.next-btn').children('span').text('Finish');
            }
            if(stepCurrent <= 1) {
                $stepperForm.find('.prev-btn').attr('disabled', true);
                $stepperForm.find('.prev-btn').addClass('disabled');
            }
            $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').addClass('d-none');
            $stepperForm.children('.stepper').children('.stepper-steps').children('.step' + stepCurrent).removeClass('d-none');
            $stepperForm.find('#postCode').children('.item-pc').each(function() {
                let radius = parseFloat($(this).find('.input-radius').val());
                let latitude = parseFloat($(this).find('.input-lat').val());
                let longitude = parseFloat($(this).find('.input-lng').val());
                coordinate.push({lat: latitude, lng: longitude, radius: radius });
            });
            mapMarker.showMarker(postCode.centerInit, coordinate);
        }
    }

    function createUser(formData) {
        formData.append('action', 'create_user');
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            let response = JSON.parse(res);
            if (response.status) {
                $stepperForm.attr('user-id', response.user_id);
                $stepperForm.find('.prev-btn').attr('disabled', true);
                $stepperForm.find('.prev-btn').addClass('disabled');
            } else {
                //alert(response.error);
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    function updateDetails(formData) {
        formData.append('action', 'update_details');
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            let response = JSON.parse(res);
            if (response.status) {
                $stepperForm.attr('post-id', response.post_id);
            } else {
                //alert(response.error);
            }
        }).fail(function (error) {
            console.log(error);
        });
    }

    function updateMapMarkers(formData) {
        formData.append('action', 'update_map_markers');
        formData.append('post_id', $stepperForm.attr('post-id'));
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            //let response = JSON.parse(res);
        }).fail(function (error) {
            console.log(error);
        });
    }

    function updateAdviceAndSpecialties(formData) {
        formData.append('action', 'update_advice_and_specialties');
        formData.append('post_id', $stepperForm.attr('post-id'));
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            let response = JSON.parse(res);
        }).fail(function (error) {
            console.log(error);
        });
    }

    function updateFees(formData) {
        formData.append('action', 'update_fees');
        formData.append('post_id', $stepperForm.attr('post-id'));
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            let response = JSON.parse(res);
        }).fail(function (error) {
            console.log(error);
        });
    }

    function createPayment(formData) {
        formData.append('action', 'create_payment');
        formData.append('post_id', $stepperForm.attr('post-id'));
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            $('.stepper-footer .next-btn span').text('redirectig...');
            let response = JSON.parse(res);
            if(response.checkout_session !== '') {
                window.location = response.checkout_session.url;
            }
        }).fail(function (error) {
            $('.stepper-footer .next-btn span').text('error');
            console.log(error);
        });
    }

    // Initial Form
    function initStepper() {
        let initStepsCount = $stepperForm.children('.stepper').children('.stepper-steps').children('.jq-step').size();
        progressBar.init($stepperForm, initStepsCount, 0);

        if($stepperForm.length) {
            postCode.showMap();
        }

        $stepperForm.find('.file-link').children('.label-link').on('click', function (e) {
            e.preventDefault();
            imageField.triggerFile($stepperForm);
        });

        $stepperForm.find('.file-link').children('.upload-markrting-link').on('click', function (e) {
            e.preventDefault();
            marketingPhotoField.triggerFile($stepperForm);
        });

        jQuery(document).on('change', 'input[name="nationwide"]', function () {
            if($(this).is(':checked')) {
                $('#postCodeMap').addClass('d-none');
            } else {
                $('#postCodeMap').removeClass('d-none');
            }
            removeInvalidFocus($stepperForm.find('input[name="postcode"]'));
            removeInvalidFocus($stepperForm.find('.form-group[data-type="post_code_map"]').find('.select2-container'));
        });

        $('.leads-location-select').on('change', function() {
            if(this.value == "anywhere"){
                $('#postcode-arrea').addClass('d-none');
            }else{
                $('#postcode-arrea').removeClass('d-none');
            }
        });

        $stepperForm.find('#remove-firm-logo').on('click', function (e) {
            e.preventDefault();
            imageField.removeFile($(this));
        });

        $stepperForm.find('select[name="radius"]').change(function (e) {
            e.preventDefault();
            let postcode = $stepperForm.find('input[name="postcode"]').val();
            let radius = $stepperForm.find('select[name="radius"] :selected').val();
            if(postcode !== '' && radius !== 'none') {
                if(postCode.postCodeCount !== postCode.maxSelectPostcode) {
                    postCode.addDisabledButton($stepperForm, true);
                }
            }
        });

        $stepperForm.find('#addPostCode').on('click', function (e) {
            e.preventDefault();
            postCode.addItem($stepperForm);
        });

        jQuery(document).on('click', '.remove-post-code', function (e) {
            e.preventDefault();
            postCode.removeItem($(this));
        });

        $('.select2checkbox').each(function() {
            let placeholder = $(this).data('placeholder') || 'Default placeholder';
            $(this).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                closeOnSelect : false,
                allowClear: true,
                allowHtml: true,
                tags: true,
                placeholder: placeholder,
                templateSelection: checkboxFormat,
                templateResult: checkboxFormat,
            });
            $(this).on('select2:opening select2:closing', function() {
                let $searchField = $(this).parent().find('.select2-search__field');
                $searchField.prop('disabled', true);
            });
        });

        jQuery('.select2checkbox').next('.select2').find('.select2-search').children('textarea').attr('disabled', true);

        function checkboxFormat(item) {
            return $('<span class="item"><span class="checkbox"></span><span class="text">'+item.text+'</span></span>');
        }

        $('.select2custom').each(function() {
            let placeholder = $(this).data('placeholder') || 'Default placeholder';
            $(this).select2({
                width: '100%',
                minimumResultsForSearch: -1,
                placeholder: placeholder,
                multiple: false,
            });
        });

        $('.form-group[data-type="text"]').children('input[type="text"]').keydown(function () {
            $(this).val($(this).val().substr(0,50));
        });

        $stepperForm.find('input[name="contact_name"]').keypress(function(event) {
            return /[а-яА-ЯёЁa-zA-Z /s]/i.test(event.key);
        });

        $stepperForm.find('input[name="broker_name"]').keypress(function(event) {
            return /^[а-яА-ЯёЁa-zA-Z0-9!@#$%\^&*)(+=._-]*$/i.test(event.key);
        });

        $stepperForm.find('input[type="tel"]').keypress(function(event) {
            return /\d/.test(String.fromCharCode(event.keyCode));
        });
    }

    // Helper functions
    function validateField($element) {
        let error = true;
        $element.children('.jq-step-content').children('.form-group').each(function() {
            switch($(this).data('type')) {
                case 'text': {
                    let $field = $(this).children('input[type="text"]');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '') {
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'phone': {
                    let $field = $(this).children('input[type="tel"]');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '') {
                        $field.addClass('is-invalid');
                        error = false;
                    } else {
                        //error = phoneValidate($field);
                    }
                    break;
                }
                case 'email': {
                    let $field = $(this).children('input[type="email"]');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && emailExistsQuery($field)) {
                        $field.addClass('is-invalid');
                        $field.next('.invalid-feedback').text();
                        error = false;
                    }
                    break;
                }
                case 'password': {
                    let $field = $(this).find('input[type="password"]');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '') {
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'textarea': {
                    let $field = $(this).children('textarea');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '') {
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'number': {
                    let $field = $(this).children('input[type="number"]');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '') {
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'file': {
                    let $field = $(this).children('.company_logo_input');
                    removeInvalidFocus($field);
                    if($field.hasAttr('required') && $field.val() === '' && $('#company-logo-output').attr('src') == "") {
                        $field.next('.invalid-feedback').css('display', 'block');
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'agree': {
                    let $field = $(this).children('.form-check');
                    removeInvalidFocus($field);
                    if($field.children('input[type="checkbox"]').hasAttr('required') && !$field.children('input[type="checkbox"]').is(':checked')) {
                        $field.addClass('is-invalid');
                        error = false;
                    }
                    break;
                }
                case 'post_code_map': {
                    let $checkNationwide = $(this).find('input[name="nationwide"]');
                    removeInvalidFocus($('.leads-location-container').children('.select2-container'));
                    if($('.leads-location-select').val().length == 0) {
                        error = false;
                        $('.leads-location-container').children('.select2-container').addClass('is-invalid');
                    }
                    if($('.leads-location-select').val() != '' && $('.leads-location-select').val() != 'anywhere') {
                        removeInvalidFocus($(this).find('input[name="postcode"]'));
                        removeInvalidFocus($('#postcode-arrea').find('.select2-container'));
                        if($('#postCode').hasAttr('required') && $('#postCode').children('.col-xl-4').size() === 0) {
                            error = false;
                            $(this).find('input[name="postcode"]').addClass('is-invalid');
                            $('#postcode-arrea').find('.select2-container').addClass('is-invalid');
                        }
                    } else {
                        removeInvalidFocus($(this).find('input[name="postcode"]'));
                        removeInvalidFocus($('#postcode-arrea').find('.select2-container'));
                    }
                    break;
                }
                case 'select': {
                    let $field = $(this).children('.select2checkbox-container');
                    removeInvalidFocus($field.children('.select2-container'));
                    if($field.children('select').hasAttr('required') && $field.children('select').val().length === 0) {
                        error = false;
                        $field.children('.select2-container').addClass('is-invalid');
                    }
                    break;
                }
                case 'package': {
                    if(!$('input[name="packages_product').is(':checked')) {
                        error = false;
                        alert('Please select your Package!');
                    }
                    break;
                }
            }
        });
        return error;
    }

    function removeInvalidFocus($field) {
        $field.removeClass('is-invalid');
        $field.on('focus', function () {
            $(this).removeClass('is-invalid');
        });
        $field.on('click', function () {
            $(this).removeClass('is-invalid');
        });
    }

    function emailExistsQuery($field) {
        let status = false;
        let formData = new FormData();
        formData.append('action', 'email_exists');
        formData.append('email_address', $field.val());
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
            async: false,
        }).done(function (res) {
            let response = JSON.parse(res);
            status = !(response.errors.length === 0);
            if(response.errors.length) {
                response.errors.forEach((item) => {
                    $field.next('.invalid-feedback').html(item);
                });
            }
        }).fail(function (error) {
            console.log(error);
        });
        return status;
    }

    $('.hint-icon, .hint-section .cancel-btn').on('click', function (e) {
        $(this).closest('.hint-section').find('.hint-text').toggle();
        $('.hint-shadow').toggleClass('d-none');
    });
});




// WEBPACK FOOTER //
// ./scripts/stepper/stepper.js